import React from "react";
import styled from "styled-components";
import OptionLabel from "./OptionLabel";

/**
 * Links between different apparel fits
 * Ex: Adult, Women, Youth
 *
 * @param {Object} productType   Type of current product
 * @param {string} imageIds      Existing image IDs
 *
 * @returns {Object}
 */
export default function ApparelFitLinks({ productType, imageIds }) {
  // Load new fit type
  const changeFit = (fit) => {
    const queryString = new URLSearchParams(imageIds).toString();
    const shirtUrl = getUrl(fit);
    window.location.href = shirtUrl + queryString;
  }

  // Get fit's url
  const getUrl = (fit) => {
    let shirtUrl = "/products/";
    switch (fit) {
      case "tshirt":
        shirtUrl += "adult-t-shirt?";
        break;
      case "tshirt-youth":
        shirtUrl += "youth-t-shirt?";
        break;
      case "tshirt-womens":
        shirtUrl += "womans-t-shirt?";
        break;
      case "crewneck":
        shirtUrl += "adult-crewneck-sweatshirt?";
        break;
      case "crewneck-youth":
        shirtUrl += "youth-crewneck-sweatshirt?";
        break;
      case "hoodie":
        shirtUrl += "adult-hoodie-sweatshirt?";
        break;
      case "hoodie-youth":
        shirtUrl += "youth-hoodie-sweatshirt?";
        break;
      case "polo":
        shirtUrl += "mens-polo-shirt?";
        break;
      case "polo-womens":
        shirtUrl += "womens-polo-shirt?";
        break;
      case "polo-youth":
        shirtUrl += "youth-polo-shirt?";
        break;
    }
    return shirtUrl;
  }

  // Loop through fit types
  const loopFits = () => {
    const current = productType.split("-")[0];
    const fits = {
      tshirt: {
        tshirt: "Adult",
        "tshirt-womens": "Women's",
        "tshirt-youth": "Youth"
      },
      crewneck: {
        crewneck: "Adult",
        "crewneck-youth": "Youth"
      },
      hoodie: {
        hoodie: "Adult",
        "hoodie-youth": "Youth"
      },
      polo: {
        polo: "Adult",
        "polo-womens": "Women's",
        "polo-youth": "Youth"
      }
    };

    return Object.keys(fits[current]).map((index) => {
      return (
        <div
          key={index}
          onClick={() => changeFit(index)}
          className={productType == index ? "selected" : ""}
        >
          {fits[current][index]}
        </div>
      );
    });
  }

  return (
    <ApparelLinks>
      <OptionLabel label={"Type"} />
      <div className="tshirtFits">{loopFits()}</div>
    </ApparelLinks>
  );
}

const ApparelLinks = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
